import {
  Box,
  Grid,
  TextField,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import Input from "../../../../../../components/Input";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function PersonalInformationForm(props: any) {
  const {
    personalData,
    consultantName,
    policyData,
    onPersonalInfoCommentChange,
    personalInfoComment,
    isAssigned,
    claimStatus,
    commentData,
    isEditable,
    handlePersonalDataFieldChange,
  } = props;

  const comments = commentData?.filter(
    (comment: any) => comment.section_type === "CLAIMANT_PERSONAL_INFORMATION"
  );

  const formatDate = (dateString: string) => {
  const d = new Date(dateString);
  return `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`;
};

  return (
    <Grid
      container
      rowSpacing={5}
      columnSpacing={10}
      mt={1}
      textAlign="left"
      p={3}
    >
      <Grid size={{ xs: 12, md: 4 }}>
        <Input
          disabled={!isEditable}
          value={personalData.first_name}
          height={40}
          width="100%"
          label="First name"
          backgroundColor="background.paper"
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <Input
          disabled={!isEditable}
          value={personalData.last_name}
          height={40}
          width="100%"
          label="Last name"
          backgroundColor="background.paper"
        />
      </Grid>

      <Grid size={{ xs: 12, md: 4 }}>
        <Input
          disabled={!isEditable}
          value={personalData.address}
          height={40}
          width="100%"
          label="Address"
          backgroundColor={
            isEditable ? "background.default" : "background.paper"
          }
          onChange={(e: any) =>
            handlePersonalDataFieldChange("address", e.target.value)
          }
        />
      </Grid>

      <Grid size={{ xs: 12, md: 4 }}>
        <Input
          disabled={!isEditable}
          value={personalData.contact_number}
          height={40}
          width="100%"
          label="Contact number"
          backgroundColor={
            isEditable ? "background.default" : "background.paper"
          }
          onChange={(e: any) =>
            handlePersonalDataFieldChange("contact_number", e.target.value)
          }
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <Input
          disabled={!isEditable}
          value={personalData.email}
          height={40}
          width="100%"
          label="Email"
          backgroundColor={
            isEditable ? "background.default" : "background.paper"
          }
          onChange={(e: any) =>
            handlePersonalDataFieldChange("email", e.target.value)
          }
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <Input
          disabled={!isEditable}
          value={personalData.identification_number}
          height={40}
          width="100%"
          label="Identification number"
          backgroundColor="background.paper"
        />
      </Grid>

      <Grid size={{ xs: 12, md: 4 }}>
        <Input
          disabled={!isEditable}
          value={personalData.identification_type}
          height={40}
          width="100%"
          label="Identification type*"
          backgroundColor="background.paper"
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <Input
          disabled={!isEditable}
          value={policyData.policy_number}
          height={40}
          width="100%"
          label="Policy number"
          backgroundColor="background.paper"
          onChange={(e: any) =>
            handlePersonalDataFieldChange("policy_number", e.target.value)
          }
        />
      </Grid>
      {comments?.length > 0 && (
        <Grid size={12}>
          {comments.map((comment: any, index: number) => (
            <Accordion
              key={index}
              sx={{
                backgroundColor: "#F7F7F7",
                boxShadow: "none",
                borderRadius: "6px",
                mb: 2,
                border: "1px solid #E0E0E0",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel${index}-content`}
                id={`panel${index}-header`}
                sx={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box>
                  <Typography fontWeight={600} fontSize={14}>
                    {comment.commentedByName}{" "}
                    <Typography
                      component="span"
                      fontWeight={600}
                      color="#EC6E00"
                    >
                      - {comment.role_at_time_of_comment?.toUpperCase()}
                    </Typography>
                  </Typography>
                  <Typography fontSize={12} color="text.secondary">
                    {new Date(comment.created_on).toLocaleTimeString("en-US", {
                      hour: "numeric",
                      minute: "2-digit",
                    })}{" "}
                    |{" "}
                    {formatDate(comment.created_on)}
                  </Typography>
                </Box>
              </AccordionSummary>

              <AccordionDetails>
                <Typography fontSize={15} color="#333" lineHeight={1.6}>
                  {comment.content}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Grid>
      )}
      {isAssigned && claimStatus !== "PAID" && (
        <Grid size={{ md: 12 }}>
          <Typography
            variant="body1"
            fontWeight={600}
            fontSize={18}
            sx={{ display: "block", textAlign: "left" }}
          >
            Comment
          </Typography>
          <TextField
            multiline
            rows={4}
            variant="outlined"
            fullWidth
            disabled={isEditable}
            value={personalInfoComment}
            onChange={onPersonalInfoCommentChange}
          />
        </Grid>
      )}
    </Grid>
  );
}
